var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTargetOne(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 18062 18062",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    fillRule: "evenodd",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ef5350",
    d: "M14413 9201c-54 0-109-15-158-45-142-87-186-273-99-415 582-945 889-2033 889-3147 0-1115-307-2203-889-3148-87-141-43-327 99-415 142-87 328-43 415 99 640 1040 978 2238 978 3464s-338 2423-978 3463c-57 93-156 144-257 144zm-10764 0c-101 0-200-51-257-144-640-1040-978-2237-978-3463s338-2424 978-3464c87-142 273-186 415-99 142 88 186 274 99 415-581 945-889 2033-889 3148 0 1114 308 2202 889 3147 87 142 43 328-99 415-49 30-104 45-158 45zM6077 18062H451c-167 0-302-135-302-301v-1293c0-879 715-1594 1594-1594h3041c879 0 1594 715 1594 1594v1293c0 166-135 301-301 301z",
    opacity: 1,
    "data-original": "#ef5350"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc39c",
    d: "M3264 14193c-994 0-1802-808-1802-1802 0-993 808-1802 1802-1802 993 0 1802 809 1802 1802 0 994-809 1802-1802 1802z",
    opacity: 1,
    "data-original": "#ffc39c",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe270",
    d: "M17612 18062h-5626c-167 0-302-135-302-301v-1293c0-879 715-1594 1594-1594h3041c879 0 1594 715 1594 1594v1293c0 166-135 301-301 301z",
    opacity: 1,
    "data-original": "#ffe270",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc39c",
    d: "M14799 14193c-994 0-1803-808-1803-1802 0-993 809-1802 1803-1802 993 0 1802 809 1802 1802 0 994-809 1802-1802 1802z",
    opacity: 1,
    "data-original": "#ffc39c",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c9cee",
    d: "M11001 18062H7062c-167 0-302-135-302-301v-905c0-665 541-1207 1206-1207h2130c665 0 1206 542 1206 1207v905c0 166-135 301-301 301z",
    opacity: 1,
    "data-original": "#5c9cee"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc39c",
    d: "M9031 15354c-745 0-1352-607-1352-1352 0-746 607-1353 1352-1353 746 0 1352 607 1352 1353 0 745-606 1352-1352 1352z",
    opacity: 1,
    "data-original": "#ffc39c",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9031 10828c-1461 0-2866-617-3856-1694-106-116-106-293 0-408 598-651 1354-1143 2187-1423 90-30 189-16 267 37 414 283 899 433 1402 433 504 0 989-150 1402-433 79-53 177-67 267-37 833 280 1589 772 2187 1423 106 115 106 292 0 408-989 1077-2395 1694-3856 1694zM5819 8930c860 826 2015 1295 3212 1295s2353-469 3212-1295c-459-442-1005-786-1600-1007-485 297-1039 453-1612 453s-1127-156-1612-453c-595 221-1141 565-1600 1007zM9031 7074c-1371 0-2486-1116-2486-2487s1115-2486 2486-2486 2486 1115 2486 2486-1115 2487-2486 2487zm0-4370c-1038 0-1883 845-1883 1883 0 1039 845 1883 1883 1883s1883-844 1883-1883c0-1038-845-1883-1883-1883z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#5c9cee"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1620 2931c-166 0-301-135-301-302V1306c0-166 135-301 301-301 167 0 302 135 302 301v1323c0 167-135 302-302 302z",
    fill: "#5c9cee",
    opacity: 1,
    "data-original": "#5c9cee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2282 2270H959c-167 0-302-136-302-302 0-167 135-302 302-302h1323c167 0 302 135 302 302 0 166-135 302-302 302zM16419 10574c-167 0-302-135-302-302V8949c0-167 135-302 302-302s302 135 302 302v1323c0 167-135 302-302 302z",
    fill: "#5c9cee",
    opacity: 1,
    "data-original": "#5c9cee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17081 9912h-1324c-166 0-301-135-301-302 0-166 135-301 301-301h1324c166 0 301 135 301 301 0 167-135 302-301 302z",
    fill: "#5c9cee",
    opacity: 1,
    "data-original": "#5c9cee"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ef5350",
    d: "M9031 11187c-3084 0-5594-2509-5594-5593C3437 2509 5947 0 9031 0s5594 2509 5594 5594c0 3084-2510 5593-5594 5593z",
    opacity: 1,
    "data-original": "#ef5350"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c44544",
    d: "M9031 802c-2642 0-4792 2149-4792 4792 0 2642 2150 4792 4792 4792s4792-2150 4792-4792c0-2643-2150-4792-4792-4792z",
    opacity: 1,
    "data-original": "#c44544"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe270",
    d: "M5297 8594c879 1092 2226 1792 3734 1792s2855-700 3734-1792c-573-551-1264-971-2016-1224-89-30-186-16-263 37-430 293-933 449-1455 449s-1025-156-1454-449c-78-53-175-67-264-37-752 253-1442 673-2016 1224z",
    opacity: 1,
    "data-original": "#ffe270",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc39c",
    d: "M9031 6963c-1256 0-2279-1023-2279-2279s1023-2279 2279-2279c1257 0 2279 1023 2279 2279s-1022 2279-2279 2279z",
    opacity: 1,
    "data-original": "#ffc39c",
    className: ""
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetOne);
export default __webpack_public_path__ + "static/media/targetOne.b0968ca889239c30b4c471e886072638.svg";
export { ForwardRef as ReactComponent };